<template>
	<div>
		<el-table class="group-list" :data="data" border :show-header="isHeader" @row-click="handleRowClick($event)">
			<el-table-column :label="$t('contacts.contactPerson')">
				<template slot-scope="scope">
					<div class="container">
						<div class="left">
							<ChatAvatar :avatar="scope.row.avatar" borderRadius="50%" size="35" class="avatar" />
						</div>
						<div class="right">
							<div class="group-name" :title="scope.row.nick_name">{{ scope.row.nick_name }}</div>
						</div>
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import ChatAvatar from "./chat-avatar.vue";
export default {
	name: "Contacts",
	components: {
		ChatAvatar,
	},
	props: {
		data: {
			type: Array,
			required: true,
		},
		isHeader: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	methods: {
		// 列表点击
		handleRowClick(event) {
			this.$emit("row-click", event);
		},
	},
};
</script>

<style lang="less" scoped>
.container {
	display: flex;
	flex: 1;
	align-items: center;
	gap: 10px;
	cursor: pointer;
}

.left {
	display: flex;
}

.right {
	display: flex;
	flex: 1;

	.group-name {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 280px;
	}
}
</style>
